import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { RowWrap } from "./styles";

export default function Row({ label, value, bold }) {
  return (
    <RowWrap>
      <Typography variant="body2" color="textSecondary">
        {bold ? <strong>{label}</strong> : label}
      </Typography>
      <Typography variant="body2" style={bold ? { fontWeight: 600 } : null}>
        {bold ? <strong>{value}</strong> : value}
      </Typography>
    </RowWrap>
  );
}

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  bold: PropTypes.bool,
};
